import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResourceService } from './resource';
import { CacheService } from '../cache';
import { AuditLogAdminParams, AuditLogBusinessParams } from '../../models/audit-log';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService extends ResourceService<any> {
  constructor(protected http: HttpClient, protected cache: CacheService) {
    super(http, cache, 'audit-logs');
  }

  /**
   * Sends a GET request to the /audit-logs/admin endpoint
   * @remarks
   * to get audit logs for admin
   * @param {AuditLogAdminParams} params Filter parameters
   * @returns {Observable} Returns an observable of any
   */
  getAdminAuditLogs(params?: AuditLogAdminParams | any) {
    return this.http.get<any>(`${this.endpoint}/admin`, { params }).pipe(
      map((resp: any) => {
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      })
    );
  }

  /**
   * Sends a GET request to the /audit-logs/business/:business_id endpoint
   * @remarks
   * to get audit logs for a specific business
   * @param {string} business_id Business ID
   * @param {AuditLogBusinessParams} params Filter parameters
   * @returns {Observable} Returns an observable of any
   */
  getBusinessAuditLogs(business_id: string, params?: AuditLogBusinessParams | any) {
    return this.http.get<any>(`${this.endpoint}/business/${business_id}`, { params }).pipe(
      map((resp: any) => {
        // clear related cache if needed, keeping consistency with getAdminAuditLogs
        this.cache.remove(`${this.endpoint}`);
        this.cache.remove(`${this.endpoint}`);
        return resp;
      })
    );
  }
}
